import AVELA from "../../assets/pics/avela.svg";
import A from "../../assets/pics/a.svg";
import { useDeviceWidth } from "../../hooks/useDeviceWidth";
import Button from "../ui/Button";
import Text from "../ui/Text";

function Main() {
  const deviceWidth = useDeviceWidth();
  const isMobile = deviceWidth <= 640;
  return !isMobile ? (
    <section className="flex flex-col h-[100lvh] w-full px-5 mt-[100px] sm:px-[30px] pt-5 sm:pt-[30px] gap-[-60px] relative">
      <div className="flex flex-col gap-8">
        <Text type="h1" className="leading-[100%]">
          {
            <>
              Создаём сайты, <br /> Telegram-приложения
              <br /> и выстраиваем IT-инфраструктуру
            </>
          }
        </Text>
        <Button className="w-fit" href="#form">
          Обсудить проект
        </Button>
      </div>
      <img
        src={AVELA}
        alt="AVELA picture"
        className="absolute -bottom-0 -z-10 w-[120vw]  left-1/2 transform -translate-x-1/2 "
      />
    </section>
  ) : (
    <section className="flex flex-col h-[calc(100svh-100px)] w-full px-5 sm:px-[30px] relative">
      <div className="absolute -z-10  left-1/2 transform -translate-x-[58%] max-w-[100vw] w-full ">
        <img src={A} alt="A picture" className="min-w-[144vw] left-0" />
      </div>
      <p className="text-h1-mobile xs:text-[42px] font-magic absolute top-[15vw] left-1/2 transform -translate-x-1/2">
        avela
      </p>
      <Text type="h1" className="absolute bottom-0 max-w-[calc(100vw-40px)]">
        Создаём сайты,&#10;&#13;Telegram-приложения и&nbsp;выстраиваем IT-инфраструктуру
      </Text>
    </section>
  );
}

export default Main;
